import { render, staticRenderFns } from "./BudgetsTable.vue?vue&type=template&id=0cf6fe89&"
import script from "./BudgetsTable.vue?vue&type=script&lang=js&"
export * from "./BudgetsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports